var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spe-split",style:(_vm.commonStyle),attrs:{"ddt-area":("component_" + (_vm.json.floorId)),"ddt-expose":"on"}},[_c('div',{style:(_vm.lineStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }